import TextBox from "../../components/textfield/textbox";
import "../../assets/styles/components/jobcost.scss";
import { Input, TextareaBox } from "../../components/textfield";
import { Table, TableColumn } from "../../components/table";
import { useHistory, useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import CheckboxText from "../../components/textfield/checkbox";
import HeaderBar from "../../components/header/headerBar";
import { useState, useEffect } from "react";
import MainButton from "../../components/button/mainButton";

interface ParamsType {
  id: string;
}
const JobCostView = () => {
  const { id } = useParams<ParamsType>();

  const history = useHistory();
  const [title, setTitle] = useState("JOB COST MAIN");
  const [customer, setCustomer] = useState<string>("");
  const [chaanel, setChannel] = useState<string>("");
  const [proceDure, setProceDure] = useState<string>("");
  const [isSo, setIsSo] = useState<string>("");
  const [refNo, setRefNo] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [startProcedureTime1, setStartProcedureTime1] = useState<string>("");
  const [endtProcedureTime1, setEndProcedureTime1] = useState<string>("");
  const [startProcedureTime2, setStartProcedureTime2] = useState<string>("");
  const [endtProcedureTime2, setEndProcedureTime2] = useState<string>("");
  const [time1, setTime1] = useState<string>("");
  const [time2, setTime2] = useState<string>("");
  const [handValueAmount, setHandValueAmount] = useState<string>("");
  const [totalUsed, setTotalUsed] = useState<string>("");
  const [priceValue, setPriceValue] = useState<string>("");

  const columns = [
    {
      title: "",
    },
    {
      title: "รายการ",
    },
    {
      title: "ชื่อผู้รับเงิน",
    },
    {
      title: "จำนวนเงิน",
      align: "center",
    },
  ];
  const data = [
    {
      cn: "SalePrice (ราคาขาย)",
      list: "",
      price: "19,200.00",
    },
    {
      cn: "หัก Agent (15%)",
      list: "สง่า หมื่นภักดี",
      price: "2,800.00",
    },
    {
      cn: "หักค่า Commission (หน้าร้าน 3%)",
      list: "",
      price: "576.00",
    },
    {
      cn: "ค่าห้องผ่าตัด 10,000 บาท",
      list: "",
      price: "0.00",
    },
    {
      cn: "รวมค่าใช้จ่ายส่วนแรก",
      list: "",
      price: "3,456.00",
    },
    {
      cn: "ราคาขายหลังหักค่าใช้จ่ายส่วนแรก",
      list: "",
      price: "15,744.00",
    },
    {
      cn: "ค่าศัลยแพทย์ Surgeon (Strip)(40%)",
      list: "",
      price: "00.00",
    },
    {
      cn: "ค่าศัลยแพทย์ Surgeon (FUE)(40%)",
      list: "นพ. คณวัฒน์ กาญจนพิบูลย์",
      price: "6,297.60",
    },
    {
      cn: "Scrub Nurse (50 บาท)",
      list: "",
      price: "00.00",
    },
    {
      cn: "Hair Therapist (2)",
      list: "",
      price: "00.00",
    },
    {
      cn: "Hair Therapist (1)",
      list: "",
      price: "00.00",
    },
  ];

  const getAPIs = () => {
    setCustomer("Ms. Alice Watts");
    setProceDure(
      "(ODES0102/160/NetAmount 19,200/Quantity300 ) Hair Transplant FUE"
    );
    setChannel("EK-CNF62060025");
    setIsSo("SO-AE-07011");
    setRefNo("VN EK - 29013");
    setDate("2564-12-17");
    setStartProcedureTime1("10:30 am");
    setEndProcedureTime1("19:30 pm");
    setStartProcedureTime2("10:30 am");
    setEndProcedureTime2("19:30 pm");
    setTime1("8 ชั่วโมง 30 นาที");
    setTime2("8 ชั่วโมง 30 นาที");
    setHandValueAmount("300.00");
    setTotalUsed("9,446.40");
    setPriceValue("19,200.00");
  };

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title={title} btnBack={true} />
      <div style={{ padding: "20px 40px" }}>
        <div
          className="card-view col-12"
          style={{
            padding: "20px 40px",
            flexDirection: "column",
            fontSize: "16px",
          }}
        >
          <div className={"row mt-3"}>
            <div className="col">
              <TextBox className="col" title="Customer" value={customer} />
              <TextBox className="col" title="SO" value={isSo} />
            </div>
            <div className="col">
              <TextBox className="col" title="CN" value={chaanel} />
              <TextBox className="col" title="เลขที่ใบยา" value={refNo} />
            </div>
            {/* <TextBox className="col-6" title="Procedure" value={proceDure} /> */}
            <TextareaBox
              title="Procedure"
              rows={2}
              value={proceDure}
              readOnly={true}
              className="col-4"
            />
          </div>
          <div className={"row mt-3"} style={{ padding: "0px 10px" }}>
            <TextBox className="col-3" title="Procedure Date" value={date} />
            <Input
              className="col-2"
              title="Start Procedure Time"
              type="time"
              value={startProcedureTime1}
            />
            <Input
              className="col-2"
              title="End Procedure Time"
              type="time"
              value={endtProcedureTime1}
            />
            <TextBox className="col-2" title="" value={time1} />
            <Input
              className="col-3"
              title="จำนวนที่คิดค่ามือ"
              value={handValueAmount}
            />
          </div>
          <div className="row mt-3">
            <div className="col">
              <div style={{ padding: "13px 15px" }} className="col-1">
                <b>Anesthesia:</b>
              </div>
            </div>
            <div className="col">
              <CheckboxText className="col" id="1" title="LA (No Anesth)" />
            </div>
            <div className="col">
              <CheckboxText className="col" id="2" title="GA" />
            </div>
            <div className="col">
              <CheckboxText className="col" id="3" title="IV with Sedation" />
            </div>
            <Input
              className="col-2"
              title="Start Procedure Time"
              type="time"
              value={startProcedureTime2}
            />
            <Input
              className="col-2"
              title="End Procedure Time"
              type="time"
              value={startProcedureTime2}
            />
            <TextBox className="col-2" title="" value={time2} />
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <h5>USED COURSE DETAIL</h5>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {data.map((item, index) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    item.cn === "รวมค่าใช้จ่ายส่วนแรก"
                      ? "#E1E5F1"
                      : item.cn === "ราคาขายหลังหักค่าใช้จ่ายส่วนแรก"
                      ? "#E1F1EF"
                      : "#FFFFFF",
                }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="30%">{item.cn}</TableColumn>
                <TableColumn width="40%">{item.list}</TableColumn>
                <TableColumn width="10%" align="right">
                  {item.price}
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <div style={{ marginTop: "20px" }}>
          <div className="container overflow-hidden">
            <div className="row gx-5">
              <div className="col">
                <div className="p-3 border bg-light">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      lineHeight: "18px",
                    }}
                  >
                    ราคาขาย
                    <div style={{ display: "flex", fontWeight: "bolder" }}>
                      {priceValue}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="p-3 border bg-light">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                    }}
                  >
                    <span style={{ color: "black" }}>
                      ราคาขายหลังหักค่าใช้จ่ายผันแปร
                    </span>
                    <div
                      style={{
                        display: "flex",
                        fontWeight: "bolder",
                        color: "black",
                      }}
                    >
                      {totalUsed}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: "30px" }}>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                to={`/jobcost`}
              />
              <MainButton
                className="mg-10"
                title="พิมพ์"
                background="#4285f4"
                to={`/jobcost/view/${id}`}
              >
                <Icon path={mdiPrinter} color={`${"#FFFFFF"}`} size="20" />
              </MainButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobCostView;
